import { useEffect, useMemo, useState } from "react";
import hostProfileDetailBg from "assets/images/others/attendee-side-images/hostProfileDetailBg.png";
import { MdOutlineStar } from "react-icons/md";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "components/breadcrumbs/AttendeeBreadcrumb";
import { siteRoutes } from "utils/helpers/enums/routes";
import Overview from "./component/Overview";
import Experiences from "./component/Experiences";
import CupOfGratitude from "./component/CupOfGratitude";
import Reviews from "./component/Reviews";
import useAuth from "containers/auth/useHooks";
import useUtils from "hooks/useUtils";
import { UserDetailDTO } from "utils/helpers/models/shared/user-detail.dto";
import { HeartFillIcon, HeartICon } from "assets/images/svgs";
import useAttendee from "../useHooks";
import { getFilePathWithBackendUrl } from "utils/helpers/common/http-methods";
import { BAGDE_TYPES } from "utils/helpers/enums/shared.enum";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useStore from "hooks/useStore";

interface Tab {
  name: string;
  component: JSX.Element;
}

const HostProfileDetail = () => {
  const navigate = useNavigate();
  const { favUnfavHost, getMyBadges } = useAttendee();
  const { getUserById } = useAuth();
  const [user, setUser] = useState<UserDetailDTO>(new UserDetailDTO());
  const [data, setData] = useState<any>([]);
  const isLoading = useSelector((state: any) => state.sharedReducer.isLoading);
  const location = useLocation();
  const { isProfileCompleted } = useStore();

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.attendeeHome, { replace: true });
    }
  }, [isProfileCompleted, navigate]);

  const tabs: Tab[] = useMemo(() => {
    return [
      { name: "Overview", component: <Overview user={user} /> },
      { name: "Experiences", component: <Experiences /> },
      { name: "Cup of Gratitude", component: <CupOfGratitude /> },
      { name: "Reviews", component: <Reviews /> },
    ];
  }, [user]);
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  const HostId = params?.id;

  console.log(HostId, "HostId");

  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.attendeeHome },
    { title: "Host Profile", path: siteRoutes.attendeeHostProfileDetail },
  ];

  const toggleFavoriteHost = () => {
    if (user && user.profiles?.host?.userId) {
      user.isFavoriteHost = !user.isFavoriteHost;
      setUser({ ...user });
      favUnfavHost(user.profiles.host.userId);
    }
  };

  useEffect(() => {
    if (HostId) {
      getUserById(HostId, setUser);
    }

    // Get badges
    const payload = {
      badgeType: BAGDE_TYPES.ACHIEVEMENT,
    };
    getMyBadges(setData, payload);
  }, []);

  return (
    <div>
      <div
        style={{ backgroundImage: `url(${hostProfileDetailBg})` }}
        className="bg-cover bg-center bg-no-repeat h-full md:h-[280px] w-full"
      >
        <div className="h-full ">
          <div className="container">
            <div className="flex justify-between items-center gap-4">
              <div>
                <AttendeeBreadcrumb links={breadcrumbLinks} />
              </div>
              <div
                className="bg-white w-fit p-2 rounded-md cursor-pointer"
                onClick={toggleFavoriteHost}
              >
                {user?.isFavoriteHost ? <HeartFillIcon /> : <HeartICon />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container md:mt-[-145px]">
        <div className="flex justify-between flex-wrap gap-2 items-center">
          <div className="flex flex-wrap items-end gap-4">
            <img
              className="w-36 h-36 object-cover border-4 border-white rounded-full"
              src={getFilePathWithBackendUrl(
                user?.user?.profilePicUrl?.fileDownloadUri || ""
              )}
              alt="profilePic"
            />
            <span className="text-xl sm:text-3xl text-blackie flex items-end gap-2 font-semibold mb-4 whitespace-nowrap">
              {`${
                 user?.user?.firstName || ""
              } ${
               user?.user?.lastName || ""
              }`}{" "}
              <p className="text-base sm:text-lg text-primaryBlueText font-sm mb-0">
                {user?.profiles?.host?.businessName || ""}
              </p>
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-1 bg-yellowBg rounded-lg lg:rounded-full px-3 py-2 mt-6 text-sm">
              <span className="text-yellowText">
                <MdOutlineStar />
              </span>
              <span className="">({user?.profiles?.host?.avgRating || 0})</span>
            </div>
            {data?.length > 0 && (
              <div className="w-[210px] h-[230px] rounded-xl border bg-white flex flex-col items-center justify-center gap-2 p-4">
                <img src={getFilePathWithBackendUrl(data[0]?.image?.name)} />
                <span className="text-base text-blackie font-medium">
                  {data[0]?.name}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="container min-h-[50vh]">
        <div className=" flex flex-wrap gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`px-4 py-2 rounded-lg text-white transition-colors duration-300 ${
                activeTab.name === tab.name
                  ? "bg-lightBlueColor"
                  : "bg-grayText "
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className="mt-4">
          {activeTab.name === "Overview" ? (
            <Overview user={user} />
          ) : activeTab.name === "Experiences" ? (
            <Experiences />
          ) : activeTab.name === "Cup of Gratitude" ? (
            <CupOfGratitude />
          ) : (
            <Reviews />
          )}
        </div>
      </div>
    </div>
  );
};

export default HostProfileDetail;
